import React from "react";
import MediaQuery from "react-responsive";
import { MobileView } from "./MobileView";
import { DesktopView } from "./DesktopView";

export function FundraiserDetailPageSekeleton() {
    return <React.Fragment>
        {/* Desktop View */}
        <MediaQuery minDeviceWidth={991}>
            <DesktopView />
        </MediaQuery>

        {/* Mobile View */}
        <MediaQuery maxDeviceWidth={991}>
            <MobileView />
        </MediaQuery>
    </React.Fragment>
}